import { render, staticRenderFns } from "./DisplayAccordionOrderItems.vue?vue&type=template&id=664c4a8b&scoped=true"
import script from "./DisplayAccordionOrderItems.vue?vue&type=script&lang=js"
export * from "./DisplayAccordionOrderItems.vue?vue&type=script&lang=js"
import style0 from "./DisplayAccordionOrderItems.vue?vue&type=style&index=0&id=664c4a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c4a8b",
  null
  
)

export default component.exports